import React from "react";
const About = () => {
  return (
    <section id="about" className="about">
      <div className="about__card">
        <h3 className="about__cardHeader">About Me</h3>
        <div className="about__content">
          <p className="about__cardContent">
            Hey🙋‍♂, My name is Mankaran Singh, I am a person with deep
            knowledge of data structures, algorithms, operating systems,
            database management systems and well known web development
            frameworks/libraries like React.js,Next.js,etc. I have strong a
            understanding of Object oriented programming in C++. I also have a
            good knowledge of software development tools and life cycle.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
